import { render } from "./NegocieJa.vue?vue&type=template&id=61ba52cc"
import script from "./NegocieJa.vue?vue&type=script&lang=js"
export * from "./NegocieJa.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__